import { html } from 'lit';
import { ChevronDown } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-chevron-down')
export class PdsIconChevronDown extends PdsIcon {
  @state()
  icon = ChevronDown;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
